import { render, staticRenderFns } from "./commodityProduct.vue?vue&type=template&id=03bee1c7"
import script from "./commodityProduct.vue?vue&type=script&lang=js"
export * from "./commodityProduct.vue?vue&type=script&lang=js"
import style0 from "./commodityProduct.vue?vue&type=style&index=0&id=03bee1c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports